export const CACHE_TTL_MS = 30_000;

export const FEATURE_FLAG_NAMES = {
  FLOATING_SURVEYS: 'floating_surveys',
  RECOMMENDED_ACTIVITIES: 'recommended_activities',
  ENVIRONMENT_WALL: 'environment_wall',
  UNMATCHED_STRIPE_PAYMENT_ALERTS: 'unmatched_stripe_payment_alerts',
  COMMUNITY_SALES_ENABLED: 'community_sales_enabled',
  EMAIL_VERIFICATION_ENABLED: 'email_verification_enabled',
  ADD_REINFORCEMENT_TO_TEMPLATES: 'add_reinforcement_to_templates',
};
